import { fetchAPI } from '@/services/prismic';
import { camelize } from '@/scripts/camelize';

export const getAllBannersQuery = `
  query getAllBanners($id: String!){
    allBanners(id: $id) {
      edges {
        node {
          title
          background_image
          items {
            item {
              ... on Banner_card {
                title
                buttons {
                  primary_button {
                    ... on Call_to_action {
                      title
                      type
                      style
                      url
                      open_in_another_page
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const fetchBannerContent = async (id, previewData) => {
  const {
    allBanners: {
      edges: [{
        node: banner,
      } = {}] = [],
    } = {},
  } = await fetchAPI(getAllBannersQuery, {
    previewData,
    variables: {
      id,
    },
  });

  return camelize(banner);
};